import { Avatar, Button, CircularProgress, Tooltip } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { getAssets, getCollections } from "../../../store/reducers/asset";
import "./index.css";

interface IProps {
  address: string;
}

const AssetList = ({ address }: IProps) => {
  const { t } = useTranslation();
  const [currentCollection, setCurrentCollection] = useState<string>("");
  const { secondFontColor, brandColor } = useAppSelector(
    (state) => state.layout
  );
  const {
    isFetchingCollection,
    collections: collectionList,
    assets: assetList,
    isFetchingAsset,
    collectionNextPageKey,
    assetnNextPageKey,
  } = useAppSelector((state) => state.asset);
  const dispatch = useAppDispatch();
  const collections = collectionList[address] ?? [];
  const assets = assetList[address] ?? {};
  const scrollCollectionContainerRef = useRef();
  const scrollAssetContainerRef = useRef();

  const handleScrollCollection = () => {
    const container = scrollCollectionContainerRef.current as any;
    if (
      container.scrollLeft + container.clientWidth >=
      container.scrollWidth - 10
    ) {
      dispatch(getCollections(address, collectionNextPageKey[address]));
    }
  };

  const handleScrollAsset = () => {
    const container = scrollAssetContainerRef.current as any;
    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 10
    ) {
      dispatch(getAssets(address, assetnNextPageKey[address]));
    }
  };

  useEffect(() => {
    if (!address) return;
    if (collections.length) return;
    dispatch(getCollections(address, collectionNextPageKey[address]));
  }, [address]);

  useEffect(() => {
    if (!collections.length || assets[collections[0].slug]) return;
    setCurrentCollection(collections[0].slug);
  }, [collections]);

  useEffect(() => {
    if (assets[currentCollection] || !currentCollection) return;
    dispatch(getAssets(currentCollection, address));
  }, [currentCollection]);

  const getAssetView = () => {
    if (isFetchingAsset)
      return (
        <div className="AssetModal-fetching">
          <CircularProgress style={{ color: brandColor }} size={20} />
        </div>
      );

    if (!assets[currentCollection] || !assets[currentCollection]?.length) {
      return (
        <h3 className="AssetList-fetching">
          {t("Asset_Modal_NoAsset") + " "}
          {!!collections.length && (
            <>
              <br />
              <br />
              {t("Asset_Modal_NoAsset_2")}
            </>
          )}
        </h3>
      );
    }

    return (
      <div
        style={{ display: "flex", overflowY: "scroll" }}
        className="scroll-container"
        onScroll={handleScrollAsset}
        ref={scrollAssetContainerRef}
      >
        {assets[currentCollection]?.map((a, i) => (
          <div key={`asset_${i}`} className="AssetList-asset">
            <img src={a.imageUrl} className="AssetList-asset-img" alt="" />
          </div>
        ))}
      </div>
    );
  };

  if (!address) return <></>;

  if (isFetchingCollection)
    return (
      <div className="AssetList-fetching">
        <CircularProgress style={{ color: brandColor }} size={20} />
      </div>
    );

  return (
    <>
      {!!collections.length && (
        <SimpleBar className="AssetList-button-outer" scrollbarMinSize={50}>
          <div
            style={{ display: "flex", overflowX: "scroll" }}
            className="scroll-container"
            onScroll={handleScrollCollection}
            ref={scrollCollectionContainerRef}
          >
            {collections.map((c, i) => (
              <div key={`collection_${i}`} id={`collection_${i}`}>
                <Tooltip title={c.name} arrow disableInteractive>
                  <Button
                    size="small"
                    className={`AssetList-button ${
                      currentCollection === c.slug && "active"
                    }`}
                    type="button"
                    onClick={(e) => {
                      setCurrentCollection(c.slug);
                    }}
                  >
                    <Avatar
                      src={c.imageUrl}
                      style={{
                        width: "37px",
                        height: "37px",
                        margin: "2px",
                      }}
                    />
                  </Button>
                </Tooltip>
              </div>
            ))}
          </div>
        </SimpleBar>
      )}
      <SimpleBar className="AssetList-asset-outer">{getAssetView()}</SimpleBar>
    </>
  );
};

export default AssetList;
